export default __webpack_public_path__ + "static/media/20.99fca9e0.jpg";